import type { CampaignWeek } from '@/models/campaign-week'
import type { MealProgramSubscription } from '@/models/meal-program-subscription'
import type { MealProgramSubscriptionWeek } from '@/models/meal-program-subscription-week'
import type MealSwap from '@/models/meal-swap'
import type { SubscriptionWeekMenu } from '@/models/subscription-week-menu'
import type { UiValidationsForWeek } from '@/types/pops'
import { atom, map } from 'nanostores'

export const $subscription = atom<MealProgramSubscription | null>(null)
export const $subscriptionWeeks =
  map<Record<string, MealProgramSubscriptionWeek>>()
export const $subscriptionWeeksMenus =
  map<Record<string, SubscriptionWeekMenu>>()
export const $mealSwaps = map<Record<string, MealSwap[]>>()
export const $campaignWeeks = map<Record<string, CampaignWeek>>()
export const $skippedWeeks = atom<string[]>([])
export const $allowedChangesForWeeks =
  map<Record<string, UiValidationsForWeek>>() // TODO: use model
export const $promises = map<Record<string, Promise<any> | undefined>>()

export const loggables = {
  'meal-program-subscription/$subscription': $subscription,
  'meal-program-subscription/$subscriptionWeeks': $subscriptionWeeks,
  'meal-program-subscription/$subscriptionWeeksMenus': $subscriptionWeeksMenus,
  'meal-program-subscription/$mealSwaps': $mealSwaps,
  'meal-program-subscription/$campaignWeeks': $campaignWeeks,
  'meal-program-subscription/$skippedWeeks': $skippedWeeks,
  'meal-program-subscription/$allowedChangesForWeeks': $allowedChangesForWeeks,
  // 'meal-program-subscription/$promises': $promises,
}
